import './index.scss';
import { UnitsPermissionsTab } from './UnitsPermissionsTab';
import { UsersPermissionsTab } from './UsersPermissionsTab';
import { translate } from '@utils';
import { TabsPanel } from '@sharedComponents/TabsPanel';
import { hasPermissionFeature } from '@hooks/hasPermissionFeature';
import { FeaturePermission, PagePermission, PermissionActions } from '../../../../api/enums';

const tabPanelClasses = {
  root: 'permission-management__tab-panel',
};

export const PermissionManagementPage = () => {
  const hasUnits = hasPermissionFeature(
    PagePermission.Management,
    [FeaturePermission.ManagementUnits],
    [PermissionActions.View]
  );
  const hasUsers = hasPermissionFeature(
    PagePermission.Management,
    [FeaturePermission.ManagementUsers],
    [PermissionActions.View]
  );

  const tabsList = [];
  if (hasUnits) {
    tabsList.push({ label: translate('units'), content: <UnitsPermissionsTab /> });
  }
  if (hasUsers) {
    tabsList.push({ label: translate('users'), content: <UsersPermissionsTab /> });
  }
  return (
    <div className={'permission-management'}>
      <TabsPanel tabsList={tabsList} tabPanelClasses={tabPanelClasses} />
    </div>
  );
};
